import './styles.scss'
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { useTranslation } from 'react-i18next'
import { Button } from 'primereact/button'
import { TABLE_CONST } from 'Utils/Constants'
import { DialogModal } from 'Components/UIComponents'
import { commonMethods } from 'Utils/commonMethods'
import apiAdapterCoffeeWeb from 'Services/apiAdapterCoffeeWeb'
import LayoutContainer from 'Components/LayoutComponent'
import Loader from 'Components/Loader'

const MissingInvoiceNumberReport = ({ setLoading, mockMissingInvoiceReport, mockGetFetchedData }) => {
  const { t } = useTranslation()

  let rowCount = 5
  const windowSize = window.innerWidth
  let paginationButtons = TABLE_CONST.paginationButtonCount

  const [getFetchedData, setGetFetchedData] = useState([])
  const [showDialog, setShowDialog] = useState({ showModal: false, modalType: '', message: '', onHide: () => {}, onRetry: () => {}, onConfirmation: () => {}, onSuccess: () => {} })

  if (windowSize < TABLE_CONST.maxWidthTab) {
    rowCount = TABLE_CONST.mobileRowCount
    paginationButtons = TABLE_CONST.mobilePaginationButtonCount
  }

  useEffect(() => {
    getMissingReport()

    // Testing Purpose
    if (mockMissingInvoiceReport) {
      setGetFetchedData(mockGetFetchedData)
    }
  }, [])

  const getMissingReport = async () => {
    setLoading(true)

    try {
      const response = await apiAdapterCoffeeWeb.getMissingInvoiceReport()

      if (response?.data?.returnLst?.length) {
        const modifiedData = response.data.returnLst.map((item) => {
          const invoiceDate = commonMethods.utcToLocalTime(item.invoiceDate)

          return {
            ...item,
            invoiceDate
          }
        })

        setGetFetchedData(modifiedData)
      }
    } catch {
      setShowDialog({
        ...showDialog,
        showModal: true,
        modalType: 'error',
        message: t('GET_API_FAILED'),
        onHide: handleDismiss,
        onRetry: getMissingReport
      })
    } finally {
      setLoading(false)
    }
  }

  const postMissingInvoiceReport = async (item) => {
    setLoading(true)

    const formatDate = (dateStr) => {
      const dateObj = moment(dateStr, 'MMMM D, YYYY [at] h:mm A')

      return dateObj.toISOString()
    }

    const postData = [
      {
        idInvoice: item.idInvoice,
        userInvoice: item.userInvoice,
        invoiceDate: formatDate(item.invoiceDate)
      }
    ]

    try {
      const response = await apiAdapterCoffeeWeb.postCancelledInvoiceOrder(postData)

      const modifiedData = getFetchedData.filter((item) => item.idInvoice !== response.data.returnLst[0].idInvoice)

      setGetFetchedData(modifiedData)
      setShowDialog({
        ...showDialog,
        showModal: true,
        modalType: 'success',
        message: t('MARKED_AS_CANCELLED_MESSAGE'),
        onHide: handleDismiss,
        onSuccess: handleDismiss
      })
    } catch {
      setShowDialog({
        ...showDialog,
        showModal: true,
        modalType: 'error',
        message: t('FAILED_TO_CANCELLED_THE_REPORT'),
        onHide: handleDismiss,
        onRetry: () => postMissingInvoiceReport(item)
      })
    } finally {
      setLoading(false)
    }
  }

  const handleDismiss = () => {
    setShowDialog({
      ...showDialog,
      showModal: false
    })
  }

  const handleClick = (item) => {
    setShowDialog({
      ...showDialog,
      showModal: true,
      modalType: 'info',
      message: t('CANCELLED_INVOICE_MESSAGE'),
      onConfirmation: () => postMissingInvoiceReport(item),
      onHide: handleDismiss
    })
  }

  const handleAction = (rowData) => (
    <Button type="button" className="cancel-button" onClick={() => handleClick(rowData)}>
      {t('MARK_AS_CANCEL')}
    </Button>
  )
  const columns = [
    { field: 'userInvoice', header: t('USER_INVOICE'), className: 'user-invoice-column' },
    { field: 'invoiceDate', header: t('INVOICE_DATE'), className: 'invoice-date-column' },
    { body: handleAction, header: t('ACTION'), className: 'action-column' }
  ]

  return (
    <div>
      <LayoutContainer title={'MISSING_INVOICE_REPORT'} breadCrumbsTitle={'missingInvoiceReport'}>
        <div className="missing-invoice-report-table-wrapper" data-testid="missing-invoice-report-table-wrapper">
          <DataTable value={getFetchedData} paginator={getFetchedData?.length} rows={rowCount} pageLinkSize={paginationButtons}>
            {columns.map((col, index) => (
              <Column key={index} field={col.field} header={col.header} body={col.body} className={col.className} />
            ))}
          </DataTable>
        </div>
      </LayoutContainer>
      <DialogModal {...showDialog} onHide={handleDismiss} onDismiss={handleDismiss} />
    </div>
  )
}

export default Loader(MissingInvoiceNumberReport)
